export default __webpack_public_path__ + "static/media/81298D32-9E9A-4643-BCE3-13D0E7261D29_1_105_c.7f794048.jpg";